import { render, staticRenderFns } from "./MedCategoryPicker.vue?vue&type=template&id=17a83a6b&scoped=true&"
import script from "./MedCategoryPicker.vue?vue&type=script&lang=js&"
export * from "./MedCategoryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a83a6b",
  null
  
)

export default component.exports